import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Paste = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.867 36.218c0-.5.398-.898.897-.898h14.852c.498 0 .897.399.897.898a.894.894 0 0 1-.897.898H17.764a.894.894 0 0 1-.897-.898ZM16.867 28.236c0-.499.398-.898.897-.898h14.852c.498 0 .897.399.897.898a.894.894 0 0 1-.897.898H17.764a.894.894 0 0 1-.897-.898ZM24.243 20.154c0-.499.399-.898.897-.898h7.376c.498 0 .897.4.897.898a.894.894 0 0 1-.897.898H25.14a.894.894 0 0 1-.897-.898Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.326 6.086h-3.488V3.392a.894.894 0 0 0-.898-.898h-2.192C21.95.998 20.455 0 18.76 0c-1.794 0-3.289.998-3.987 2.494H12.58c-.498 0-.897.4-.897.898v2.694H8.195c-.997 0-1.695.798-1.695 1.696V35.72a1.68 1.68 0 0 0 1.695 1.696H9.39c.498 0 .897-.4.897-.898a.894.894 0 0 0-.897-.898H8.195V7.882h21.131V9.38c0 .499.4.898.898.898s.897-.4.897-.898V7.882c-.1-.998-.897-1.796-1.795-1.796ZM13.378 4.29h1.894c.398 0 .697-.2.797-.598.3-1.098 1.396-1.896 2.592-1.896 1.196 0 2.193.798 2.591 1.896.1.399.4.598.798.598h1.894v1.796H13.378V4.29Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.905 12.571H21.95c-.498-.1-.797.1-1.096.5l-7.576 7.582c-.299.3-.498.699-.498 1.098v20.653c0 .898.697 1.596 1.595 1.596h21.53c.897 0 1.595-.698 1.595-1.596V14.168c0-.898-.698-1.597-1.595-1.597Zm-15.051 2.994v4.988H15.87l4.984-4.988Zm14.852 26.54H14.574V22.248h6.38c.896 0 1.594-.698 1.594-1.596v-6.385h13.158v27.836ZM12.58 7.882h-.199.2ZM25.04 7.882h-.2.2Z"
  }));
});
Paste.displayName = 'Paste';
Paste.defaultProps = {
  'aria-label': 'Paste'
};
export default Paste;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Paste.js
// module id = 2934
// module chunks = 11